import {
  IconButton as MuiIconButton,
  IconButtonProps as MuiIconButtonProps,
  Tooltip as MuiTooltip,
  TooltipProps as MuiTooltipProps,
} from '@mui/material';

import { Icon, IconChildComponentProps } from '../Icon';
import { BaseComponentProps } from '../types';

export interface IconButtonProps
  extends BaseComponentProps,
    IconChildComponentProps,
    Pick<
      MuiIconButtonProps,
      | 'color'
      | 'onClick'
      | 'disabled'
      | 'edge'
      | 'size'
      | 'type'
      | 'disableRipple'
    > {
  tooltip?: MuiTooltipProps['title'];
  tooltipPlacement?: MuiTooltipProps['placement'];
  variant?: 'filled' | 'outlined';
  iconOnly?: boolean; // Remove padding around icon
  withBorder?: boolean;
}

export const IconButton = ({
  icon,
  iconProps,
  color = 'secondary',
  tooltip,
  iconOnly,
  tooltipPlacement,
  withBorder,
  ...buttonProps
}: IconButtonProps) => (
  <MuiTooltip title={tooltip} placement={tooltipPlacement}>
    <MuiIconButton
      color={color}
      {...buttonProps}
      sx={{
        border: withBorder ? 1 : 0,
        padding: iconOnly ? 0 : undefined,
      }}
    >
      <Icon {...iconProps}>{icon}</Icon>
    </MuiIconButton>
  </MuiTooltip>
);
